import { useCallback, useEffect, useState } from "react";
import { equipmentAPI } from "../services/equipmentAPI";
import { useProjectContext } from "./useProjectContext";

export const useEquipment = () => {
  const { activeProject, currentUser } = useProjectContext();
  const projectId = activeProject?.id;

  const [items, setItems] = useState([]);
  const [overview, setOverview] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [options, setOptions] = useState({ types: [], rooms: [], skids: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(
    async ({ filters = {}, dimension = "room" } = {}) => {
      if (!projectId) return;
      setLoading(true);
      setError(null);
      try {
        const external = currentUser?.role === "user_external";
        const [listRes, overviewRes, taskRes, optionRes] = await Promise.all([
          equipmentAPI.list(projectId, filters),
          equipmentAPI.overview(projectId, dimension),
          equipmentAPI.listTasks(projectId, external ? { mine: true } : {}),
          equipmentAPI.options(projectId),
        ]);
        setItems(listRes?.data?.items || []);
        setOverview(overviewRes?.data || null);
        setTasks(Array.isArray(taskRes?.data) ? taskRes.data : []);
        setOptions(optionRes?.data || { types: [], rooms: [], skids: [] });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [projectId, currentUser?.role],
  );

  useEffect(() => {
    load();
  }, [load]);

  return {
    projectId,
    items,
    overview,
    tasks,
    options,
    loading,
    error,
    reload: load,
    setItems,
    setOverview,
    setTasks,
    setOptions,
  };
};
